module.exports = __webpack_public_path__ + "1dffc408f85d5c819e2a4ca20dcb2268.pdf";